/**
 * Request body for createPublicShareLink API
 */
export interface RequestBody {
    /** Task ID */
    task_id: string;
    /** Password (optional) */
    password?: string;
}

/**
 * Combined request parameters for createPublicShareLink API
 */
export interface RequestParams {
    body: RequestBody;
}

/**
 * Response data interface for createPublicShareLink API
 */
export interface ResponseData {
    /** Share ID */
    share_id: string;
    /** Whether this is a public share */
    public_share: boolean;
    /** User role */
    user_role: string;
}

/**
 * API interface for createPublicShareLink
 */
export interface CreatePublicShareLinkApi {
    /**
   * Create a public share link
   *
   * @param params - Request parameters including request body
   * @returns Promise resolving to response data with share information
   */
    createPublicShareLink(params: RequestParams): Promise<ResponseData>;
}

/**
 * Symbol for dependency injection
 */
export const CreatePublicShareLinkApi = Symbol.for('CreatePublicShareLinkApi');
